module.exports = __webpack_public_path__ + "02bbb2296d454d7fa9826ece007a87b2.png";